import type { IconSvgObject } from './types';

const CornerLeftDownIcon: IconSvgObject = [
  ["path", { d: "M9 19.002L9 12.002C9 8.23072 9 6.3451 10.1716 5.17353C11.3431 4.00195 13.2288 4.00195 17 4.00195L20 4.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 15.002C4 15.002 7.68244 20.0019 9.00004 20.002C10.3176 20.002 14 15.002 14 15.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerLeftDownIcon;
